export const INSTALLMENT_TABLE_COLUMNS = [
  {
    key: 'installment',
    label: 'Parcelamento',
    type: 'currency',
    defaultValue: 0,
    placeholder: '0',
    style: {
      flex: 2,
      maxWidth: '300px',
    },
    prefix: '',
  },
  {
    key: 'interestRate',
    label: 'Juros',
    type: 'currency',
    defaultValue: '0',
    placeholder: '0,00%',
    style: {
      flex: 4,
      maxWidth: '300px',
    },
    prefix: '',
    suffix: '%',
  },
]

export const INSTALLMENT_TABLE_COLUMNS_WITH_ACTION = [
  ...INSTALLMENT_TABLE_COLUMNS,
  {
    key: 'remove',
    label: '',
    type: 'remove',
    defaultValue: null,
    style: {},
  },
]

export const INSTALLMENT_TABLE_DEFAULT_ITEM = Object.fromEntries(
  INSTALLMENT_TABLE_COLUMNS.map(column => [column.key, null])
)

export const ADD_PROBLEM_FORM_DEFAULT_VALUES = {
  problem: null,
  problemDescription: '',
  serviceDescription: '',
  warrantyMonths: null,
  isServiceMandatory: null,
  installmentsTotal: null,
  laborValue: null,
  numberOfProfessionals: null,
  laborTimeHours: null,
  problemMedia: [],
  installments: [INSTALLMENT_TABLE_DEFAULT_ITEM],
}
